export default __webpack_public_path__ + "static/media/07.26c742ed.jpg";